export default __webpack_public_path__ + "static/media/atribuir-treino-mobile-staff.3c1ba90f.png";